import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";

const VAT_MULTIPLIER = 1.23;

const formatCurrency = (value: number) =>
	new Intl.NumberFormat("pt-PT", {
		style: "currency",
		currency: "EUR",
		maximumFractionDigits: 2,
	}).format(value);

const normalizeNumber = (value: number | null | undefined) => {
	const parsed = Number(value ?? 0);
	return Number.isNaN(parsed) ? 0 : parsed;
};

type RepairMaterialEntry = {
	id?: string | number | null;
	quantity?: number | null;
	name?: string | null;
	price?: number | null;
};

type PrevRepairMaterialsTableProps = {
	materials: RepairMaterialEntry[];
};

export function PrevRepairMaterialsTable({
	materials,
}: PrevRepairMaterialsTableProps) {
	return (
		<div className="overflow-hidden rounded-lg border border-border/60 bg-card/70">
			<Table>
				<TableHeader>
					<TableRow className="bg-muted/50">
						<TableHead className="w-[70px]">Qtn.</TableHead>
						<TableHead>Descrição</TableHead>
						<TableHead className="w-[110px] text-center">Preço</TableHead>
						<TableHead className="w-[150px] text-center">
							Preço C/ IVA
						</TableHead>
					</TableRow>
				</TableHeader>
				<TableBody>
					{materials.map((material, index) => {
						const price = normalizeNumber(material.price);
						const rowKey =
							material.id ?? `${material.name ?? "material"}-${index}`;

						return (
							<TableRow key={rowKey}>
								<TableCell>{material.quantity ?? "-"}</TableCell>
								<TableCell>{material.name ?? "-"}</TableCell>
								<TableCell className="text-center">
									{formatCurrency(price)}
								</TableCell>
								<TableCell className="text-center">
									{formatCurrency(price * VAT_MULTIPLIER)}
								</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</div>
	);
}
